export default function MyComisionsRoute() {
  return (
    <div className="container-md width-full">
      <div className="p-responsive py-6 color-bg-default rounded-2 border">
        <h1>Mis honorarios</h1>
      </div>
    </div>
  );
}
